import { Create, Form, Input, Row, Col, Button, Icons, notification } from '@pankod/refine-antd';
import { useNavigation } from '@pankod/refine-core';
import { ICategory } from 'interfaces';
import { useState } from 'react';
import { createExpenseCategory } from 'services/expense-category';

interface IExpense extends ICategory { }

export const ExpenseCategoryCreate: React.FC = () => {
  const [isSubmitButtonLoading, setIsSubmitButtonLoading] = useState<boolean>(false);

  const { push, goBack } = useNavigation();

  const onFinish = async (values: IExpense) => {
    setIsSubmitButtonLoading(true);
    try {
      const data = {
        name: values.name,
        description: values.description,
      };

      await createExpenseCategory(data);
      push('/expenses/expense-categories');
    } catch (err) {
      notification.error({
        message: 'Failed',
        description: 'Failed to update company info',
      });
    }
    setIsSubmitButtonLoading(false);
  };

  return (
    <Create
      title="Create Category"
      headerButtons={<></>}
      pageHeaderProps={{ onBack: goBack }}
    >
      <Form layout="vertical" onFinish={onFinish}>
        <Row justify="space-around" align="middle">
          <Col xs={24} lg={12}>
            <Form.Item
              label="Name"
              name="name"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item label="Description" name="description">
              <Input.TextArea rows={8} />
            </Form.Item>
            <Form.Item wrapperCol={{ span: 4, offset: 20 }} style={{ marginTop: '2rem' }}>
              <Button
                type="primary"
                htmlType="submit"
                icon={<Icons.SaveOutlined />}
                loading={isSubmitButtonLoading}
              >
                Save
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Create>
  );
};
